const metricTrendFragment = `
  currentValue
  previousValue
  percentageChange
`;

export const getTrafficByCommunityQuery = `
  query CommunityTraffic(
    $reportFilter: ReportFilterArgs!
  ) {
    results: communityTraffic(reportFilter: $reportFilter) {
      id
      name
      visitorsCount
    }
  }
`;

export const getTrafficByCommunityAndProjectQuery = `
  query CommunityProjectTraffic(
    $reportFilter: ReportFilterArgs!
  ) {
    results: communityProjectTraffic(reportFilter: $reportFilter) {
      id 
      name
      visitorsCount
      type
    }
  }
`;

export const getTrafficByModelAndBuildingModelQuery = `
  query ModelBuildingModelTraffic(
    $reportFilter: ReportFilterArgs!
  ) {
    results: modelBuildingModelTraffic(reportFilter: $reportFilter) {
      id
      name
      visitorsCount
      type
    }
  }
`;

export const getTrafficByDeviceQuery = `
  query DeviceTraffic(
    $reportFilter: ReportFilterArgs!
  ) {
    results: deviceTraffic(reportFilter: $reportFilter) {
      name
      visitorsCount
    }
  }
`;

export const getVisitorTrafficQuery = `
  query VisitorTraffic(
    $reportFilter: ReportFilterArgs!
  ) {
    results: visitorTraffic(reportFilter: $reportFilter) {
      dateDivision
      visitors
      returningVisitors
    }
  }
`;

export const getLeadGenerationQuery = `
  query LeadGeneration(
    $reportFilter: ReportFilterArgs!
  ) {
    results: leadGeneration(reportFilter: $reportFilter) {
      dateDivision
      capturedLeads
    }
  }
`;

export const getLeadLocationQuery = `
  query LeadLocation(
    $reportFilter: ReportFilterArgs!
  ) {
    results: leadLocation(reportFilter: $reportFilter) {
      lat
      lng
      weight
    }
  }
`;

export const getTopElevationsQuery = `
  query TopElevations(
    $reportFilter: ReportFilterArgs!
  ) {
    results: topElevations(reportFilter: $reportFilter) {
      id
      name
      elevationsCount
    }
  }
`;

export const getTopFloorSelectionsQuery = `
  query TopFloorSelections(
    $reportFilter: ReportFilterArgs!
  ) {
    results: topFloorSelections(reportFilter: $reportFilter) {
      floorId
      floorOptionId
      floorGroupId
      name
      selectionsCount
    }
  }
`;

export const getMasterAdminMetricsQuery = `
  query MasterAdminMetrics(
    $filter: MasterAdminReportFilterInput!
    $sort: SortInput
  ) {
    results: masterAdminMetrics(filter: $filter, sort: $sort) {
      company {
        id
        name
      }
      websiteVisitors {
        ${metricTrendFragment}
      }
      ownlyVisitors {
        ${metricTrendFragment}
      }
      totalVisitors {
        ${metricTrendFragment}
      }
      websiteReturningVisitors {
        ${metricTrendFragment}
      }
      ownlyReturningVisitors {
        ${metricTrendFragment}
      }
      totalReturningVisitors {
        ${metricTrendFragment}
      }
      websiteNewLeads {
        ${metricTrendFragment}
      }
      ownlyNewLeads {
        ${metricTrendFragment}
      }
      newLeads {
        ${metricTrendFragment}
      }
      verificationStarted {
        ${metricTrendFragment}
      }
      verificationCompleted {
        ${metricTrendFragment}
      }
      reservationStarted {
        ${metricTrendFragment}
      }
      reservationCompleted {
        ${metricTrendFragment}
      }
    }
  }
`;

export const getTrafficSourcesQuery = `
  query TrafficSources(
    $reportFilter: ReportFilterArgs!
  ) {
    results: trafficSources(reportFilter: $reportFilter) {
      dateDivision
      visitorSessions
    }
  }
`;

export const getVerifiedAgesQuery = `
  query VerifiedAges(
    $reportFilter: ReportFilterArgs!
  ) {
    results: verifiedAges(reportFilter: $reportFilter) {
      range
      customersCount
    }
  }
`;

export const getVerifiedAffordabilitiesQuery = `
  query VerifiedAffordabilities(
    $reportFilter: ReportFilterArgs!
  ) {
    results: verifiedAffordabilities(reportFilter: $reportFilter) {
      range
      customersCount
      customersPercentage
    }
  }
`;

export const getVerifiedFunnelQuery = `
  query VerifiedFunnel(
    $reportFilter: ReportFilterArgs!
  ) {
    results: verifiedFunnel(reportFilter: $reportFilter) {
      name
      customersCount
    }
  }
`;

export const getVerifiedLeadsLocationQuery = `
  query VerifiedLeadsLocation(
    $reportFilter: ReportFilterArgs!
  ) {
    results: verifiedLeadsLocation(reportFilter: $reportFilter) {
      lat
      lng
      weight
    }
  }
`;

export const getUtmSourceReportQuery = `
  query UtmSourceReport(
    $reportFilter: ReportFilterArgs!
  ) {
    results: utmSourceReport(reportFilter: $reportFilter) {
      utmSource
      visitorsCount
      leadsCount
    }
  }
`;

export const getUtmCampaignReportQuery = `
  query UtmCampaignReport(
    $reportFilter: ReportFilterArgs!
  ) {
    results: utmCampaignReport(reportFilter: $reportFilter) {
      utmCampaign
      visitorsCount
      leadsCount
    }
  }
`;

export const getUtmContentReportQuery = `
  query UtmContentReport(
    $reportFilter: ReportFilterArgs!
  ) {
    results: utmContentReport(reportFilter: $reportFilter) {
      utmContent
      visitorsCount
      leadsCount
    }
  }
`;

export const getUtmMediumReportQuery = `
  query UtmMediumReport(
    $reportFilter: ReportFilterArgs!
  ) {
    results: utmMediumReport(reportFilter: $reportFilter) {
      utmMedium
      visitorsCount
      leadsCount
    }
  }
`;

export const getDashboardMetricsQuery = `
  query DashboardMetrics(
    $reportFilter: ReportFilterArgs!
  ) {
    result: dashboardMetrics(reportFilter: $reportFilter) {
      visitors {
        ${metricTrendFragment}
      }
      returningVisitors {
        ${metricTrendFragment}
      }
      newLeads {
        ${metricTrendFragment}
      }
      reservations {
        ${metricTrendFragment}
      }
      verifications {
        ${metricTrendFragment}
      }
      homesSaved {
        ${metricTrendFragment}
      }
    }
  }
`;

export const getReservationsMetricsQuery = `
  query ReservationsMetrics(
    $reportFilter: ReportFilterArgs!
  ) {
    results: reservationsMetrics(reportFilter: $reportFilter) {
      dateDivision
      reservationsStartedCount
      reservationsCompletedCount
    }
  }
`;

export const getTotalReservationsMetricsQuery = `
  query TotalReservationsMetrics(
    $reportFilter: ReportFilterArgs!
  ) {
    results: totalReservationsMetrics(reportFilter: $reportFilter) {
      ${metricTrendFragment}
    }
  }
`;

export const getTotalDepositAmountMetricsQuery = `
  query TotalDepositAmountMetrics(
    $reportFilter: ReportFilterArgs!
  ) {
    results: totalDepositAmountMetrics(reportFilter: $reportFilter) {
      ${metricTrendFragment}
    }
  }
`;

export const getCommunityProjectReservationsQuery = `
  query CommunityProjectReservations(
    $reportFilter: ReportFilterArgs!
  ) {
    results: communityProjectReservations(reportFilter: $reportFilter) {
      id 
      name
      reservationsCount
      type
    }
  }
`;

export const getModelBuildingModelReservationsQuery = `
  query ModelBuildingModelReservations(
    $reportFilter: ReportFilterArgs!
  ) {
    results: modelBuildingModelReservations(reportFilter: $reportFilter) {
      id 
      name
      reservationsCount
      type
    }
  }
`;

export const getReservationCustomerLocationsQuery = `
  query ReservationCustomerLocations(
    $reportFilter: ReportFilterArgs!
  ) {
    results: reservationCustomerLocations(reportFilter: $reportFilter) {
      lat
      lng
      weight
    }
  }
`;

export const getReservationFunnelQuery = `
  query ReservationFunnel(
    $reportFilter: ReportFilterArgs!
  ) {
    results: reservationFunnel(reportFilter: $reportFilter) {
      name
      customersCount
    }
  }
`;

export const getPublishedVsUnpublishedInventoryQuery = `
  query PublishedVsUnpublishedInventory(
    $reportFilter: ReportFilterArgs!
  ) {
    results: publishedVsUnpublishedInventory(reportFilter: $reportFilter) {
      date
      publishedCount
      unpublishedCount
    }
  }
`;

export const getTotalInventoryValueQuery = `
  query TotalInventoryValue(
    $reportFilter: ReportFilterArgs!
  ) {
    total: totalInventoryValue(reportFilter: $reportFilter)
  }
`;

export const getTotalPublishedListingsMetricsQuery = `
  query TotalPublishedListingsMetrics(
    $reportFilter: ReportFilterArgs!
  ) {
    results: totalPublishedListingsMetrics(reportFilter: $reportFilter) {
      ${metricTrendFragment}
    }
  }
`;

export const getTotalNewListingsMetricsQuery = `
  query TotalNewListingsMetrics(
    $reportFilter: ReportFilterArgs!
  ) {
    results: totalNewListingsMetrics(reportFilter: $reportFilter) {
      ${metricTrendFragment}
    }
  }
`;

export const getHighestPublishedListingsMetricsQuery = `
  query HighestPublishedListingsMetrics(
    $reportFilter: ReportFilterArgs!
  ) {
    results: highestPublishedListingsMetrics(reportFilter: $reportFilter) {
      ${metricTrendFragment}
    }
  }
`;

export const getSoldInventoryMetricsQuery = `
  query SoldInventoryMetrics(
    $reportFilter: ReportFilterArgs!
  ) {
    results: soldInventoryMetrics(reportFilter: $reportFilter) {
      ${metricTrendFragment}
    }
  }
`;

export const getAvgInventoryMetricsQuery = `
  query AvgInventoryMetrics(
    $reportFilter: ReportFilterArgs!
  ) {
    results: avgInventoryMetrics(reportFilter: $reportFilter) {
      ${metricTrendFragment}
    }
  }
`;

export const getReservationRateMetricsQuery = `
  query ReservationRateMetrics(
    $reportFilter: ReportFilterArgs!
  ) {
    metrics: reservationRateMetrics(reportFilter: $reportFilter) {
      reservationRate
      reservedCount
      publishedCount
    }
  }
`;

export const getInventoryListingPricesQuery = `
  query InventoryListingPrices(
    $reportFilter: ReportFilterArgs!
  ) {
    items: inventoryListingPrices(reportFilter: $reportFilter) {
      id
      price
    }
  }
`;

export const getCommunityProjectInventoryQuery = `
  query CommunityProjectInventory(
    $reportFilter: ReportFilterArgs!
  ) {
    items: communityProjectInventory(reportFilter: $reportFilter) {
      id
      name
      entityType
      publishedCount
      soldCount
      reservedCount
      inventoryValue
      absorptionRate
    }
  }
`;

export const getModelInventoryQuery = `
  query ModelInventory(
    $reportFilter: ReportFilterArgs!
  ) {
    items: modelInventory(reportFilter: $reportFilter) {
      id
      name
      entityType
      publishedCount
      soldCount
      reservedCount
      inventoryValue
      absorptionRate
    }
  }
`;

export const getSalesProfileMetricsQuery = `
  query SalesProfileMetrics {
    metrics: salesProfileMetrics {
      visitorsCount
      leadsCount
      inventoryItemsCount
    }
  }
`;

export const getSalesDashboardProfileViewMetricsQuery = `
  query SalesDashboardProfileViewMetrics(
    $reportFilter: ReportFilterArgs!
  ) {
    metrics: salesDashboardProfileViewMetrics(reportFilter: $reportFilter) {
      ${metricTrendFragment}
    }
  }
`;

export const getSalesDashboardDealMetricsQuery = `
  query SalesDashboardDealMetrics(
    $reportFilter: ReportFilterArgs!
  ) {
    metrics: salesDashboardDealMetrics(reportFilter: $reportFilter) {
      ${metricTrendFragment}
    }
  }
`;
